import { defineComponent as _defineComponent } from 'vue'
import type { NewImageV1, ImageV1 } from '@ilteducation/content-registry-types';
import { ref, withDefaults } from 'vue';
import type { Language } from '@ilteducation/content-ref-data-types';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import ChipField from '@/components/base/ChipField.vue';
import BaseState from '@/foundations/helpers/baseStates';
import useMediaFormFeature from '@/comp/use-media-form-feature';

type Props = {
  id?: string;
  title: string;
  item?: NewImageV1 | ImageV1;
  redirect?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
    id: null,
    title: null,
    item: null,
    redirect: { default: 'edit' }
  },
  setup(__props: any) {

const props = __props as { id?: string, title: string, item?: NewImageV1 | ImageV1, redirect: string }


const availableLanguages = ref<Language[]>([]);
const {
  uploadMedia,
  saveButtonAvailable,
  isCloneMode,
  publishButtonAvailable,
  toggleStateInProgress,
  toggleMediaState,
  getStateColor,
} = useMediaFormFeature(props.item);
const def = { type: 'ImageV1', realm: 'all' };

return { __sfc: true,props, availableLanguages, uploadMedia, saveButtonAvailable, isCloneMode, publishButtonAvailable, toggleStateInProgress, toggleMediaState, getStateColor, def, DisableableButton, ChipField, BaseState }
}

})